<template>
  <div class="confirmation-summary--property-details">
    <ConfirmationSummaryRow
      v-for="cf in orderedVisibleNonInternalCFs"
      :key="cf.definitionId"
      :label="cf.label">
      <span>{{cf.value}}</span>
    </ConfirmationSummaryRow>
  </div>
</template>

<script>
import ConfirmationSummaryRow from '@/components/ConfirmationSummaryRow.vue';
import PropertyDetailsMixin from '@/mixins/PropertyDetailsMixin';
import { mapState } from 'vuex';

const fieldMappings = {
  yearBuilt: {
    regex: /year built/i,
    label: 'Year Built:',
  },
  squareFootage: {
    regex: /square footage/i,
    label: 'Square Footage:',
  },
  bedrooms: {
    regex: /bedrooms/i,
    label: 'Bedrooms:',
  },
  bathrooms: {
    regex: /full bathrooms/i,
    label: 'Bathrooms:',
  },
  halfBathrooms: {
    regex: /half bathrooms/i,
    label: 'Half-Bathrooms:',
  },
  mls: {
    regex: /mls/i,
    label: 'MLS#:',
  },
  propertyOccupied: {
    regex: /occupied/i,
    label: 'Property Occupied:',
  },
  hasPower: {
    regex: /power/i,
    label: 'Power On:',
  },
  hasWater: {
    regex: /water/i,
    label: 'Water On:',
  },
  hasGas: {
    regex: /gas/i,
    label: 'Gas On:',
  },
};

export default {
  components: {
    ConfirmationSummaryRow,
  },
  mixins: [PropertyDetailsMixin],
  props: {
    model: {
      type: Object,
      required: true,
    },
    customFields: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('Appointment', {
      locationComponentData: state => state.locationComponentData,
    }),
    orderedVisibleNonInternalCFs() {
      return this.customFields
        .filter(field => field.displayStatus === 'visible' && !field.internal)
        .map(field => {
          if (field.default) {
            const defaultField = Object.entries(fieldMappings)
              // eslint-disable-next-line
              .find(([_, obj]) => obj.regex.test(field.description));
            if (defaultField) {
              let value = this.model[defaultField[0]];
              if (typeof value === 'boolean') {
                value = value ? 'Yes' : 'No';
              } else {
                value = value || 'n/a';
              }
              return {
                label: defaultField[1].label,
                value,
                id: field.id,
              };
            }
          }
          return {
            label: field.name,
            value: this?.model?.customFields?.find(cf => cf?.definitionId === field.id)?.value || 'n/a',
            id: field.id,
          };
        });
    },
  },
};
</script>
